var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.content)?_c('rich-text',{attrs:{"content":_vm.content,"is-encrypt":_vm.is_encrypt === 1,"watermark":_vm.watermark}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }